import { DateValue } from '@internationalized/date';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';
import { anyDateToISOString } from '~/shared/utils/dateTime';

export type GenerateNachaFileParams = {
  financialAccountId: string;
  paymentIds: string[];
  effectiveEntryDate: DateValue;
};

export const generateNachaFileAtom = createMutationAtomFactory(
  'finance.generateNachaFile',
  (params: GenerateNachaFileParams) => ({
    financeGenerateNachaFile: {
      __args: {
        input: {
          financialAccountId: params.financialAccountId,
          paymentIds: params.paymentIds,
          effectiveEntryDate:
            anyDateToISOString(params.effectiveEntryDate) ?? '',
        },
      },
      fileContent: true,
      entryCount: true,
      totalAmount: true,
    },
  }),
);
